var _rect, _polyline, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationIconFollowedGames(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "24px-followed-games-01 copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 6,
    width: 12,
    height: 12,
    rx: 3.5,
    fill: "none",
    stroke: "#343434",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "3 8 7 12 3 16",
    fill: "none",
    stroke: "#343434",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 12,
    x2: 6.83,
    y2: 12,
    fill: "none",
    stroke: "#343434",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationIconFollowedGames);
export default __webpack_public_path__ + "static/media/navigation-icon-followed-games.c5700b10bc5be2c559a2ed6eb31061a7.svg";
export { ForwardRef as ReactComponent };